import { GET_CIRCUIT_VPN_LOGS, GET_CIRCUIT_VPN_DETAILS_BY_EVENTS } from "./actionTypes"

export const getCircuitVpnLogsInit = (requestParams) => ({
    type: GET_CIRCUIT_VPN_LOGS.INIT,
    requestParams
})

export const getCircuitVpnLogsSuccess = (logs) => ({
    type: GET_CIRCUIT_VPN_LOGS.SUCCESS,
    payload: logs
})

export const getCircuitVpnLogsError = (error) => ({
    type: GET_CIRCUIT_VPN_LOGS.ERROR,
    payload: error
})

export const getCircuitVpnDetailsByEventsInit = (id) => ({
    type: GET_CIRCUIT_VPN_DETAILS_BY_EVENTS.INIT,
    id
})

export const getCircuitVpnDetailsByEventsSuccess = (details) => ({
    type: GET_CIRCUIT_VPN_DETAILS_BY_EVENTS.SUCCESS,
    payload: details
})

export const getCircuitVpnDetailsByEventsError = (error) => ({
    type: GET_CIRCUIT_VPN_DETAILS_BY_EVENTS.ERROR,
    payload: error
})